import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as select from '../data/selector'
import ReCAPTCHA from "react-google-recaptcha"
import { Header, Input, Checkbox, Table, Form, Button,Label } from "semantic-ui-react";
import Group_724 from "../../../image/Group_724.png"
import Group_732 from "../../../image/Group_732.png"
import { Formik, Field, Form as FormikForm } from "formik";
import {FormikInputComponent,FormikCheckBoxComponent,FormikSelectComponent} from "../../../utilities/formUtils";


const CompanyRegistration_four = (props) => {
    let [industryOptions,setindustryOptions]=useState([
        { key: "000", value: "Select Industry", text: "Select Industry" },
        { key: "001", value: "Automobiles and Components", text: "Automobiles and Components" },
        { key: "002", value: "Chartered Accountants / Tax Practitioners", text: "Chartered Accountants / Tax Practitioners" },
        { key: "003", value: "Commercial / Professional Services", text: "Commercial / Professional Services" },
        { key: "004", value: "Distributors / Traders", text: "Distributors / Traders" },
        { key: "005", value: "Education", text: "Education" },
        { key: "006", value: "Financial Services", text: "Financial Services" },
        { key: "007", value: "IT / ITeS", text: "IT / ITeS" },
        { key: "008", value: "Logistics", text: "Logistics" },
        { key: "009", value: "Manufacturing", text: "Manufacturing" },
        { key: "010", value: "Retail", text: "Retail" },
        { key: "011", value: "Real Estate", text: "Real Estate" },
        { key: "012", value: "Share Traders & Investors", text: "Share Traders & Investors" },
        { key: "013", value: "Others", text: "Others" }
    ]);
    let [selectedIndustry,setselectedIndustry] = useState("Select Industry");
    const isSaving = useSelector(state => select.isSaving(state,props));
    const onchangehandle = (e,data) =>{
        // console.log("target=",e,"=data=",data)
        if(data.name=="terms_and_condition"){
            props.settermsErrorclass("");
            props.settermsErrorMsg("");
            props.settermsConditionChk(data.checked ? 1 : 0)
        }else if(data.name=="industry_other"){
            props.setindustryotherErrorclass("");
            props.setindustryotherMsg("");
        }else if(e.target.name=="referral_code"){
            props.setrefCodeErrorclass("");
            props.setrefCodeErrorMsg("");
        }
    }
    const getDDValue =(value, setFieldValue, values, userProps_options,field_name)=>{
        let selectedoption = userProps_options.filter(function(model){
            if(model.value == value) return model
        });
        if(field_name=="project_name"){
            setselectedIndustry(value);
            props.setindustryErrorclass("");
            props.setindustryErrorMsg("");
        }
    }
    return (
        <div style={{display :props.displayparam}}>
            <div className="signUpContentContainer">
                <div className="chat-wrapper">
                    <div className="chat-head">
                        <h4>RealBooks Virtual Assistant</h4>
                    </div>
                    <div className="chat-boxes-wrap">
                        <div className="chat-box-rb">
                            <img src={Group_724} />
                            <p>Hurray! You are at the last step!</p>
                        </div>
                        <div className="chat-box-user">
                            <p>What Next?</p>
                            <img src={Group_732} />
                        </div>
                        <div className="chat-box-rb-2">
                            <img src={Group_724} />
                            <p>Just agree to the T&C and click on the Submit button.</p>
                        </div>
                        <div className="chat-box-user">
                            <p>Wait! What is Reseller Code?</p>
                            <img src={Group_732} />
                        </div>
                        <div className="chat-box-rb-2">
                            <img src={Group_724} />
                            <p>This is our sales partner referral code. In the case of direct registration, users can skip this part.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="signUpFormContainer">
                <div className="signUpFormHelpContainerInner gstMarkChkbox">{/*signUpBigFormContainerInnerWidth*/}
                    <div className="sign-up-head">
                        <h3 className="signuptxt">Company Registration</h3>
                    </div>
                    <div className="progress-container">
                        <div className="progress" id="progress"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle active"></div>
                    </div>
                    <div className="sign-up-form-info">
                    <Form.Group widths={2}>
                        <div className="mb-3">
                            <label for="Inputemail" className="sign-up-field-name form-label">Industry</label>
                            <Field
                                id="industry"
                                name="project_name"
                                noLabel="y"
                                component={FormikSelectComponent}
                                userProps={{ 
                                    options:industryOptions, 
                                    getValue:getDDValue,
                                    // trigger:industryStatetrigger,
                                    fixedit:selectedIndustry
                                    }}
                                placeholder = "Enter your industry"
                                style={{marginTop:"11px"}}
                                className={props.industryErrorclass}
                                iserror={props.industryErrorclass != "" ? true : false}
                                customErrorMsg = {props.industryErrorMsg}
                            />
                        </div>
                    </Form.Group>
                    {
                        selectedIndustry == "Others" ? 
                        <>
                            <Form.Group widths={2}>
                                <div className="mb-3 mb-4">
                                    <Field
                                        id="industry_other"
                                        name="industry_other"
                                        noLabel="y"
                                        component={FormikInputComponent}
                                        icontoShow = 'industry'
                                        iconPosition='left'
                                        placeholder = "Enter other industry type"
                                        // style={{marginTop:"11px"}}
                                        className={props.industryotherErrorclass}
                                        myChangeFunction = {onchangehandle}
                                        iserror={props.industryotherErrorclass != "" ? true : false}
                                        customErrorMsg = {props.industryotherMsg}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group widths={2}>
                                <div style={{height: "30px"}}></div>
                            </Form.Group>
                        </>
                        :
                        <>
                            <Form.Group widths={2}>
                                <div style={{height: "20px"}}></div>
                            </Form.Group>
                        </>
                    }
                        
                        <Form.Group widths={2}>
                            <div className="mb-3">
                                <label className="terms">
                                <Field
                                    id="terms_and_condition"
                                    name="terms_and_condition"
                                    noLabel="y"
                                    component={FormikCheckBoxComponent}
                                    icontoShow = 'credit card outline'
                                    iconPosition='left'
                                    placeholder = "Enter your referral code"
                                    style={{marginTop:"11px"}}
                                    className={props.termsErrorclass}
                                    myChangeFunction = {onchangehandle}
                                    // iserror={props.termsErrorclass != "" ? true : false}
                                    // customErrorMsg = {props.termsErrorMsg}
                                    userProps={{value:props.termsConditionChk}}
                                />
                                    <span style={{marginLeft : "10px"}}>I have read and agree to the <a href="https://realbooks.in/terms-and-conditions/" className="btn-term">Terms &amp; Conditions</a></span>
                                </label>
                                    {
                                        props.termsErrorclass == "error" ?
                                        <Label size="mini" color='red' basic pointing prompt>Please accept terms and conditions</Label> 
                                        :
                                        ""
                                    }
                            </div>
                        </Form.Group>
                        <Form.Group widths={2}>
                            <div className="mb-3 mb-4">
                                <label for="Inputemail" className="sign-up-field-nameNotImp form-label">Referral Code (if any)</label>
                                <Field
                                    id="referral_code"
                                    name="referral_code"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'credit card outline'
                                    iconPosition='left'
                                    placeholder = "Enter the sales partner referral code"
                                    style={{marginTop:"11px"}}
                                    className={props.refCodeErrorclass}
                                    myChangeFunction = {onchangehandle}
                                    iserror={props.refCodeErrorclass != "" ? true : false}
                                    customErrorMsg = {props.refCodeErrorMsg}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group widths={2}>
                            <div style={{height: "20px"}}></div>
                        </Form.Group>
                        <Form.Group widths={2}>
                            <Button
                                floated="left"
                                type="button"
                                size="medium"
                                // color="green"
                                className="btn-back"
                                onClick={props.clickBackBtn}
                                style={{ width: "94%", marginTop: "10px" }}
                            >Back</Button>
                            
                            <Button
                                floated="left"
                                type="submit"
                                size="medium"
                                color="green"
                                className="btn-next"   
                                disabled = {isSaving ? true : false}                             
                                loading = {isSaving ? true : false}                             
                                style={{ width: "94%", marginTop: "10px" }}
                            >Next</Button>
                        </Form.Group>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CompanyRegistration_four;